import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { EnumMeasureTypes } from '@library/store/measures/measures.interface';
import { TextModule } from '@library/ui/atoms/text/text.module';
import { DirectivesModule } from '@library/ui/directives/directives.module';
import { PreviewGraphComponent } from '@library/ui/molecules/preview-graph/preview-graph.component';
import { PipesModule } from '@library/utils/pipes/pipes.module';
import { WeathermapFacade } from '@store/weathermap.facade';
import * as moment from 'moment-timezone';
import { RainIconComponent } from 'src/app/side-panel/rain-card/rain-icon/rain-icon.component';

@Component({
  selector: 'app-rain-card',
  imports: [
    PreviewGraphComponent,
    TextModule,
    AsyncPipe,
    PipesModule,
    DirectivesModule,
    RainIconComponent,
  ],
  templateUrl: './rain-card.component.html',
  styleUrl: './rain-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RainCardComponent {
  type = EnumMeasureTypes.SUM_RAIN;

  station = this.weathermapFacade.selectedStation;

  rainLastHour = computed(() => {
    const lastHour = moment().subtract(1, 'hour').unix();
    const Rain = this.station().Rain ?? [];

    return Rain.reduce((rainLastHour, { x, y }) => {
      if (x >= lastHour) {
        rainLastHour += y;
      }

      return rainLastHour;
    }, 0);
  });

  rainToday = computed(() => {
    const today = moment().startOf('day').unix();
    const Rain = this.station().Rain ?? [];

    return Rain.reduce((rainToday, { x, y }) => {
      if (x >= today) {
        rainToday += y;
      }

      return rainToday;
    }, 0);
  });

  constructor(
    private readonly weathermapFacade: WeathermapFacade,
  ) {}
}
